import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { SubscriptionType } from 'src/app/shared/models/credit-service-dtos';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SubscriptionService {
    private readonly baseUrl: string;

    constructor(private http: HttpClient) {
        this.baseUrl = environment.backendUrl + '/rest/subscription';
    }

    changeSubscription(subscriptionType: SubscriptionType): Observable<void> {
        return this.http.patch<void>(this.baseUrl, { subscriptionType });
    }

    cancelSubscription(isCancel: boolean): Observable<void> {
        return this.http.delete<void>(this.baseUrl, { params: { isCancel } });
    }
}
